/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Button, Modal, themes, activateTheme } from '../../canvasComponents/index';
// messages
import messages from './messages';

function IncidentAlreadyClaimedPopUp(props) {
  const navigate = useNavigate();
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [riskUnit, setRiskUnit] = useState(null);
  const { selectedRiskUnit } = props;
  const intl = useIntl();

  useEffect(() => {
    activateTheme(themes.sonnet);
  }, []);

  useEffect(() => {
    if (selectedRiskUnit?.address?.addressLine1) {
      setRiskUnit(`${selectedRiskUnit.address.addressLine1 ? selectedRiskUnit.address.addressLine1 : ''}${selectedRiskUnit.address.city ? ` ${selectedRiskUnit.address.city}` : ''}${selectedRiskUnit.address.provinceCode ? ` ${selectedRiskUnit.address.provinceCode}` : ''}${selectedRiskUnit.address.postalCode ? ` ${selectedRiskUnit.address.postalCode}` : ''}`);
    } else if (selectedRiskUnit?.policySystemId === 'injuryOnly') {
      setRiskUnit(intl.formatMessage({ id: 'Injury only', defaultMessage: 'Injury only' }));
    } else if (selectedRiskUnit?.year) {
      setRiskUnit(`${selectedRiskUnit.year ? selectedRiskUnit.year : ''}${selectedRiskUnit.make ? ` ${selectedRiskUnit.make}` : ''}${selectedRiskUnit.model ? ` ${selectedRiskUnit.model}` : ''}`);
    }
  }, [selectedRiskUnit]);

  useEffect(() => {
    if (isButtonClicked === true) {
      props.closeIncidentAlreadyClaimedPopUp();
      navigate('/dashboard');
    }
  }, [isButtonClicked]);

  return (
    <Modal
      ariaHideApp={false}
      id="isIncidentAlreadyClaimedPopUp"
      title={intl.formatMessage({ ...messages.title })}
      isOpen={props.open}
      onRequestClose={() => setIsButtonClicked((currValue) => !currValue)}
    >
      {riskUnit
        ? (
          <p style={{ marginBottom: '10px' }}>
            <FormattedMessage {...messages.oops} values={{ riskUnit, br: <br /> }} />
          </p>
        ) : null}
      <Button primary className="pop-up-btn" onClick={() => setIsButtonClicked((currValue) => !currValue)}>
        <FormattedMessage {...messages.continue} />
      </Button>

      <Button
        ternary
        className="pop-up-btn"
        onClick={() => setIsButtonClicked((currValue) => !currValue)}
      >
        <FormattedMessage {...messages.cancel} />
      </Button>
    </Modal>

  );
}

export default injectIntl(IncidentAlreadyClaimedPopUp);
